import client from './client'

export const registerUser = (torqCloudBaseUrl: string, body: any) => client(torqCloudBaseUrl).post('/v1/users/register/', body)
